import {
    Card,
    Col, Row, Select, Typography,
} from 'antd';
import { useContext } from 'react';
import { DatadogMonitorContext } from '../context/datadogMonitor.context';
import MonitorEmbedElement from './MonitorEmbedElement';

const { Text } = Typography;

const MonitorElementsContent = () => {
    const {
        sharedMonitors, loading, selectedMonitor, selectMonitor,
    } = useContext(DatadogMonitorContext);

    return (
        <>
            <Select
                placeholder="Select a monitor"
                onChange={(value) => selectMonitor(value)}
                style={{ width: 600, marginBottom: 16 }}
                loading={loading}
                value={selectedMonitor ? selectedMonitor._id : undefined}
            >
                {sharedMonitors.map((monitor) => (
                    <Select.Option key={monitor._id} value={monitor._id}>
                        {monitor.title}
                    </Select.Option>
                ))}
            </Select>
            <Row
                align="top"
                justify="space-between"
                gutter={[16, 16]}
            >
                {selectedMonitor && (
                    <MonitorEmbedElement
                        monitor={selectedMonitor}
                    />
                )}
            </Row>

        </>
    );
};

export default MonitorElementsContent;
